import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import NavItem from '../../nav.js';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


export default function MultiSelector({ name, value, handleField }) {
  const navItemTitles = NavItem.map((item) => ({ module: item.title.toLowerCase() }));

  const handleSelectionChange = (event, newValue) => {
    handleField({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      size="small"
      sx={{ marginTop: "10px" }}
      options={navItemTitles}
      disableCloseOnSelect
      getOptionLabel={(option) => option.module}
      value={value || []}
      isOptionEqualToValue={(option, val) => option.module === val.module}
      onChange={handleSelectionChange}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.module}
          </li>
        );
      }}
      style={{ width: 500 }}
      renderInput={(params) => (
        <TextField {...params} placeholder="Select Modules" />
      )}
    />

  );
}
